import { IMessageTemplate } from "../../../../components/NewMessageEditors/NewMessageEditorWithMedia/types";

export type UserActivationAction = UserActivationActionFlow | UserActivationActionMessage

export enum UserActivationActionTypeEnum {
  Flow = 'Flow',
  Message = 'Message'
}

export type UserActivationActionFlow = {
  type: UserActivationActionTypeEnum.Flow,
  flow: string
  output: number
}

export type UserActivationActionMessage = {
  type: UserActivationActionTypeEnum.Message
  variants: Array<IMessageTemplate>
}
